// DateDisplay.jsx

// Dependencies
import { useTranslation } from 'react-i18next';

// Components
import HoursDisplay from '@/components/data/hours/HoursDisplay';

// Styling
import { homeCss } from '@digital_monorepo/styling';

const DateDisplay = ({ date, totalHours }) => {
  const { t } = useTranslation();

  return (
    <span className={homeCss.date}>
      {date}
      {totalHours && <span className={homeCss.hours}> | Total Hours: <HoursDisplay hours = {totalHours}></HoursDisplay></span>}
    </span>
  );
};

export default DateDisplay;
